import React from "react";
import "./about_summit.css";

function About_summit() {
  return (
    <div id="about">
    <div className="about_header">
      <h1 className="about_text">About Us</h1>
      </div>
      <div className="content_container">
      <div class="content">
      <p className="segment">
      Parichay is E-Cell VIT Bhopal's exclusive annual event designed to introduce freshers
to the exciting world of entrepreneurship and innovation. It is the perfect platform for
students who are curious about startups, business ideas, and the journey of turning a
concept into reality.
    <span className="responsive content_span">You will also receive OD, refreshments, goodies, certificates, and free Stockedge courses as a bonus,
Parichay is more than just an event – it’s a community where ideas are nurtured,
connections are made, and entrepreneurship is celebrated!
Whether you’re an aspiring entrepreneur or just curious about how the world of startups
works, Parichay is your entry point into this exciting ecosystem. Join us and be part of a
transformative journey at VIT Bhopal</span></p>
      <p className="segment responsive">At Parichay, you’ll get to
Learn about E-Cell: We’ll take you through what our Entrepreneurship Cell is all
about, the activities we organize, and how we support aspiring entrepreneurs on
their journey.
Hear from Industry Leaders: Get inspired by a guest speaker from the industry
who will share valuable insights on the entrepreneurial ecosystem, real-world
challenges, and success stories.
Experience Interactive Activities: Participate in engaging sessions like dance, fun
games like Pictionary Buzzer, and innovative pitching exercises that will
challenge your creativity and teamwork.
Pitch Your Ideas: As part of our 'Eureka' pitching event, you’ll get a chance to
pitch your unique business ideas and receive valuable feedback, along with the
possibility of progressing to higher rounds.</p>

         </div>
         </div>
    </div>
  );
}
export default About_summit;